import React, { FC, ReactNode, useEffect, useState } from 'react';
import { CreatePostContext } from './context';
import { CreatePostType } from 'models/posts.model';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { MealType } from 'models/meal.model';
import { BrandType } from 'models/brand.model';
import { handleApiError } from 'utils/functions';

const CreatePostProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { loadPolygons } = useDashboardContext();
  const [createPostForm, setCreatePostForm] = useState<CreatePostType>({
    heading: '',
    title: '',
    location: [],
    body: '',
    start_date: undefined,
    end_date: undefined,
    start_time: null,
    end_time: null,
    cokitchen_ids: [],
    meal_id: '',
    brand_id: '',
    post_type: ''
  });
  const [image, setImage] = useState('');
  const [disabled, setDisabled] = useState<boolean>(true);
  const [brands, setBrands] = useState<BrandType[]>([]);
  const [meals, setMeals] = useState<MealType[]>([]);

  const fetchBrands = async () => {
    if (!createPostForm.cokitchen_ids.length) return;
    try {
      const res = await apiService.post('brands/fetch', {
        data: {
          cokitchen_ids: createPostForm.cokitchen_ids
        }
      });
      setBrands(res.data.data);
    } catch (error) {
      setBrands([]);
      handleApiError(error);
    }
  };

  const fetchMeals = async () => {
    if (!createPostForm.brand_id) return;
    try {
      const res = await apiService.get('meal/bulk/brands', {
        params: {
          brand_ids: [createPostForm.brand_id]
        }
      });
      setMeals(res.data.data);
    } catch (error) {
      setMeals([]);
      handleApiError(error);
    }
  };

  useEffect(() => {
    if (createPostForm.cokitchen_ids.length > 0) {
      loadPolygons(createPostForm.cokitchen_ids);
      fetchBrands();
    }
    setCreatePostForm({
      ...createPostForm,
      location: [],
      brand_id: '',
      meal_id: ''
    });
  }, [createPostForm.cokitchen_ids]);

  useEffect(() => {
    fetchMeals();
  }, [createPostForm.brand_id]);

  return (
    <CreatePostContext.Provider
      value={{
        createPostForm,
        setCreatePostForm,
        disabled,
        setDisabled,
        brands,
        meals,
        image,
        setImage
      }}>
      {children}
    </CreatePostContext.Provider>
  );
};

export default CreatePostProvider;
